import React from "react"
import styles from "./footer.module.scss"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"


const Footer = () => {
  const date = new Date()
  const year = date.getFullYear()
  const images = useStaticQuery(graphql`
      query {
          logo: file(relativePath: { eq: "logo1.png" }) {
              childImageSharp {
                  fixed(height: 32, width: 257) {
                      ...GatsbyImageSharpFixed
                  }
              }
          }
      }
  `)
  return (
    <footer className={"footer " + styles.footer_wrapper}>
      <div className={"container " + styles.container_footer}>
        <div className={styles.brand_location}>
          <Img fixed={images.logo.childImageSharp.fixed} />
          <ul className="contact-list">
            <li><a href="mailto:info@insuranceplans.org"> info@insuranceplans.org</a></li>

            <li>phone <a href="tel:+18552683799">855-COVER-99</a></li>

            <li>
              Monday - Sunday<br />
              9:00am - 9:00pm ET
            </li>
          </ul>
        </div>
        <div className={styles.product}>
          <h2 className="footer-heading wc-open">Products</h2>
          <ul className="footer-liks">
            <li><a href="https://www.insuranceplans.org/health.html">Health Insurance</a></li>
            <li><a href="https://www.insuranceplans.org/medicare.html">Medicare Insurance</a></li>
            <li><a href="https://www.insuranceplans.org/life.html">Life Insurance</a></li>
            <li><a href="https://www.insuranceplans.org/home.html">Homeowners Insurance</a></li>
            <li><a href="https://www.insuranceplans.org/auto.html">Auto Insurance</a></li>
          </ul>
        </div>
        <div className={styles.company}>
          <h2>Company</h2>
          <ul className="footer-liks">
            <li><a href="https://www.insuranceplans.org/about.html">About Us</a></li>
            <li><a href="https://www.insuranceplans.org/blog.html">Blog</a></li>
            <li><a href="https://www.insuranceplans.org/contactus.html">Contact Us</a></li>
          </ul>
        </div>
      </div>
      <div className={styles.privacy}>
        <p>
          InsurancePlans.org is an online lead generator that works with our
          network of businesses to provide you with insurance quotes. We
          strive to help individuals and businesses match with smarter
          product or service coverage options. InsurancePlans.org is not a
          licensed broker, carrier or direct provider of insurance products
          or services. You may be required to submit health information to
          receive a quote. The information you choose to submit will help
          improve the accuracy of your quote results. All product names,
          logos, and brands are property of their respective owners. Use of
          these names, logos, and brands does not imply endorsement.
          <a href="https://www.insuranceplans.org/terms.html">Terms of Use</a> - <a
          href="https://www.insuranceplans.org/privacy.html">Privacy Policy</a>.
        </p>
      </div>
      <div className={styles.copy_rights}>
        © Copyright {year}. All Rights Reserved
      </div>
    </footer>
  )
}

export default Footer
